import React from 'react'

export const HOME_PAGE_QUERY = {
  'content_type': 'article',
  'fields.type[in]': 'Home Page',
  'order': '-sys.createdAt',
  'limit': 1
}

export const GLOBAL_FOOTER_1_QUERY = {
  'content_type': 'section',
  'fields.type[in]': 'Global Footer Part 1',
  'order': '-sys.createdAt',
  'limit': 1,
  'include': 4
}

export const GLOBAL_FOOTER_2_QUERY = {
  'content_type': 'section',
  'fields.type[in]': 'Global Footer Part 2',
  'order': '-sys.createdAt',
  'limit': 1,
  'include': 4
}

export let ARTICLE_GET = {
  'content_type': 'article',
  'sys.id': '%1',
  'include': 9
}

export function TAG_SEARCH(searchTerm) {
  return {
    'content_type': 'article',
    'fields.tag[match]': searchTerm
  }
}

export function CONTENT_SEARCH(searchTerm) {
  return {
    'content_type': 'article',
    'query': searchTerm
  }
}

export function LEGACY_URL(url) {
  return {
    'content_type': 'urlMapping',
    'fields.url': 'https://bordersforesttrust.org' + url,
  }
}
